import type { ReactNode } from 'react';
import { GuideHeader } from './GuideHeader';
import { changes } from './changelogData';

/** What changed in the API, newest first. */
export function ChangelogGuide(): ReactNode {
  return (
    <article className="docs-page">
      <GuideHeader slug="changelog" />
      {changes.map((change) => (
        <section
          key={change.title}
          className="docs-section"
          aria-labelledby={`change-${slugOf(change.title)}`}
        >
          <h2 id={`change-${slugOf(change.title)}`}>{change.title}</h2>
          <p>{change.date}</p>
          <ul className="docs-list">
            {change.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </section>
      ))}
    </article>
  );
}

function slugOf(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
